import { render, staticRenderFns } from "./LicenseInfo.vue?vue&type=template&id=9a5a91dc&scoped=true&"
import script from "./LicenseInfo.vue?vue&type=script&lang=js&"
export * from "./LicenseInfo.vue?vue&type=script&lang=js&"
import style0 from "./LicenseInfo.vue?vue&type=style&index=0&id=9a5a91dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5a91dc",
  null
  
)

export default component.exports